import type { FortuneIconProps } from '@/app_components/icons/constants';

export const Twitter = ({ className, ...props }: FortuneIconProps) => {
  return (
    <svg
      className={className}
      height='20'
      stroke='none'
      viewBox='0 0 20 20'
      width='20'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <title>Twitter icon</title>
      <mask
        height='20'
        id='mask0_469_22386'
        maskUnits='userSpaceOnUse'
        style={{ maskType: 'alpha' }}
        width='20'
        x='0'
        y='0'
      >
        <rect
          fill='#D9D9D9'
          height='20'
          width='20'
        />
      </mask>
      <g mask='url(#mask0_469_22386)'>
        <path
          d='M17 0C18.6569 0 20 1.34315 20 3V17C20 18.6569 18.6569 20 17 20H3C1.34315 20 6.44266e-08 18.6569 0 17V3C0 1.34315 1.34315 6.44255e-08 3 0H17ZM3 2.71484L8.29297 10.3711L3.27637 16.7148H5.4248L9.2959 11.8203L12.6797 16.7148H17L11.4824 8.64453L16.1729 2.71484H14.0254L10.4883 7.1875L7.42969 2.71484H3ZM6.7832 4.06152L14.4619 15.293H13.2725L5.50684 4.06152H6.7832Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
};
